import { isSameDay as isSameDay$1, getYear, getMonth, isBefore, startOfMonth, isAfter, startOfDay } from 'date-fns';

const normalizeDay = startOfDay;
function isInvalidDate(value) {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime());
  }
  if (typeof value === "number") {
    return Number.isNaN(value);
  }
  return true;
}
function isAfterDay(date, dateCompareTo) {
  return isAfter(normalizeDay(date), normalizeDay(dateCompareTo));
}
const INVALID_DATE = /* @__PURE__ */ new Date("invalid");
function isSameDay(date, dateCompareTo) {
  return dateCompareTo === null && date === null || dateCompareTo !== null && date !== null && isSameDay$1(dateCompareTo, date);
}
function isSameYearMonth(date, dateCompareTo) {
  return dateCompareTo === null && date === null || dateCompareTo !== null && date !== null && getYear(date) === getYear(dateCompareTo) && getMonth(date) === getMonth(dateCompareTo);
}
function isAfterYearMonth(...params) {
  return isAfter(startOfMonth(params[0]), startOfMonth(params[1]));
}
function isBeforeYearMonth(...params) {
  return isBefore(startOfMonth(params[0]), startOfMonth(params[1]));
}
function isAfterOrSameYearMonth(...params) {
  return isAfterYearMonth(...params) || isSameYearMonth(...params);
}
function isBeforeOrSameYearMonth(...params) {
  return isBeforeYearMonth(...params) || isSameYearMonth(...params);
}
function onDateChangeWhenChanged(params, changeCallback) {
  const { date, changedDate } = params;
  if (isSameDay(date, changedDate)) {
    return;
  }
  changeCallback(changedDate);
}

export { INVALID_DATE, isAfterDay, isAfterOrSameYearMonth, isAfterYearMonth, isBeforeOrSameYearMonth, isBeforeYearMonth, isInvalidDate, isSameDay, isSameYearMonth, onDateChangeWhenChanged };
//# sourceMappingURL=date.mjs.map
